var map = {
	"./ADNovum.png": "3Xq6",
	"./APG.png": "VH6I",
	"./Baar.png": "7U2o",
	"./BaslerKantonalbank.png": "FvYg",
	"./Biopartner.jpg": "Wash",
	"./Cham.png": "+ij9",
	"./EM.png": "WwEZ",
	"./GDELS.png": "E5A6",
	"./HGK.png": "VaWJ",
	"./Haefely.png": "/Pt0",
	"./Hünenberg.png": "LUCo",
	"./JMG.jpg": "L3iY",
	"./KantonGraubünden.png": "ybMw",
	"./LDQ.jpg": "+LIW",
	"./Menzingen.png": "HwfA",
	"./Neuheim.png": "jlJx",
	"./Oberägeri.png": "X5w4",
	"./Risch.png": "4qdw",
	"./SDE.png": "DZjW",
	"./Sertronics.png": "FxN5",
	"./Sonepar.jpg": "pgwj",
	"./Steinhausen.png": "BAyw",
	"./UMB.png": "M1wQ",
	"./Unterägeri.png": "IDk5",
	"./WDFH.jpg": "Ql8b",
	"./Walchwil.png": "w3Xy",
	"./Zug.png": "nHfH",
	"./akb.png": "Mymy",
	"./amag.png": "YgZV",
	"./baden.svg": "/9DM",
	"./bechtle.png": "PIkG",
	"./bekb.png": "YqFy",
	"./bildungsdirektion.png": "tZJI",
	"./blkb.png": "rwtL",
	"./chur.png": "letN",
	"./cler.png": "Bt66",
	"./gallo.png": "1qaK",
	"./huber-suhner.png": "/DBg",
	"./jumbo.png": "Y7C+",
	"./lgt.png": "IKaM",
	"./livit.png": "vkra",
	"./phtg.svg": "We0r",
	"./pistor.png": "IfIL",
	"./raiffeisen.png": "+xNd",
	"./ringier.png": "jTN6",
	"./sgkb.png": "nclF",
	"./stadtluzern.png": "jQ/d",
	"./swica.png": "/YMk",
	"./swisscard.png": "69ry",
	"./swisslife.png": "Ck4X",
	"./szkb.png": "dIJW",
	"./thomann.png": "xO+1",
	"./thurgau.svg": "87H4",
	"./valiant.png": "WpGe",
	"./verit.png": "URy0",
	"./zg.png": "N0ah",
	"./zkb.png": "V+Pp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ReOA";